<nav>
  <ids-mobile-header [scrollElement]="bgBaseScroll">
    <button
      id="rlp"
      [attr.aria-label]="labelBtnBack"
      (focus)="ariaLabelPage = false"
      idsMobileHeaderAction
      idsIconButton
      title="voltar"
      (click)="backPage()"
    >
      seta_esquerda
    </button>

    <h1 idsMobileHeaderTitle>Oferta de serviços</h1>
  </ids-mobile-header>
</nav>
<div style="overflow: scroll;" #bgBaseScroll tabindex="-1" [attr.aria-hidden]="ariaLabelPage">
  <div class="ids-container ids-pb-10">
    <div class="ids-row">
      <div class="ids-col-12">
        <h2>
          Que tal impulsionar seus investimentos sem custos antes de finalizar?
        </h2>
        <p class="ids-body-text description-pg ids-py-4">
          Nossas soluções levam seus investimentos para o próximo nível.
          Selecione aquelas que você prefere.
        </p>
      </div>
    </div>
    <div class="ids-row ids-py-4">
      <div class="ids-col-12">
        <div
          class="ids-card ids-p-6 ids-d-flex ids-flex-column"
          style="row-gap: 1.5rem"
        >
          <div
            class="ids-d-flex ids-align-items-center ids-color-bg-base ids-pt-3"
            style="
              gap: 1rem;
              text-align: start;
              grid-template: 2rem / auto 1fr auto;
              position: relative;
            "
          >
            <h3 class="ids-text-subtitle-01">Custódia Remunerada</h3>
            <button
              id="custodia-faq-button"
              idsActionButton
              idsTooltip="description"
              position="bottom"
              align="end"
              aria-label="mais detalhes sobre custódia remunerada"
              content="mais detalhes sobre custódia remunerada"
              class="ids-justify-content-end ids-py-6"
              (click)="openDetailFaq()"
              style="padding-right: 4px; position: absolute; right: 0"
              variant="neutral" >
              <ids-icon aria-hidden="true">ajuda_outline</ids-icon>
            </button>
          </div>
          <div>
            <p>
              Ganhe com aluguel de seus ativos sem abrir mão dos seus
              rendimentos.
            </p>
          </div>
          <form [formGroup]="formCustodia" class="form-selection">
            <ids-form-selection>
              <input
                type="checkbox"
                [formControl]="formCustodia.get('custodia')"
                idsCheckbox
                id="custodia-button"
                />
                Aceito ativar a oferta de custódia remunerada
            </ids-form-selection>
          </form>
          <div>
            <button
              id="custodia-termo-button"
              idsContextualButton
              variant="secondary"
              (click)="openDetail()"
              aria-label="Abrir termo" >
              Abrir termo
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="ids-row ids-py-4 ids-mb-10">
      <div class="ids-col-12">
        <div
          class="ids-card ids-p-6 ids-d-flex ids-flex-column"
          style="row-gap: 1.5rem" >
          <div
            class="ids-d-flex ids-align-items-center ids-color-bg-base ids-pt-3"
            style="
              gap: 1rem;
              text-align: start;
              grid-template: 2rem / auto 1fr auto;
              position: relative; ">
            <h3 class="ids-text-subtitle-01">Provedor de Liquidez (RLP)</h3>
            <button
              id="rlp-faq-button"
              idsActionButton
              idsTooltip="description"
              position="bottom"
              (click)="openFaq()"
              align="end"
              aria-label="mais detalhes sobre o Provedor de Liquidez RLP"
              content="mais detalhes sobre o Provedor de Liquidez  RLP"
              class="ids-justify-content-end ids-py-6"
              style="padding-right: 4px; position: absolute; right: 0"
              variant="neutral">
              <ids-icon aria-hidden="true">ajuda_outline</ids-icon>
            </button>
          </div>
          <div>
            <p>Busque os melhores preços na execução das suas ordens.</p>
          </div>
          <form [formGroup]="formRlp" class="form-selection">
            <ids-form-selection class="form-selection">
              <input
                type="checkbox"
                [formControl]="formRlp.get('rlp')"
                idsCheckbox
                id="rlp-button"
              />
              Aceito ativar a oferta de provedor de liquidez 
            </ids-form-selection>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="area-button" [attr.aria-hidden]="ariaLabelPage">
  <app-ion-common-button
    [loading_verify]="loadingVerify"
    [approved_verify]="approved"
    [label]="labelButton"
    [ariaLive]="false"
    (clickButton)="clickNext()"
  >
  </app-ion-common-button>
  <div class="sr-only" *ngIf="voicePagePost" aria-live="assertive">
    {{ labelButton }}
  </div>
</footer>
